import { render, staticRenderFns } from "./CardRoundHeader.vue?vue&type=template&id=14c35b73&lang=pug"
import script from "./CardRoundHeader.vue?vue&type=script&lang=js"
export * from "./CardRoundHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports